import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-227b9223"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "closefriend-hero background-white" }
const _hoisted_2 = { class: "container mt-5" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "tab-content w-100" }
const _hoisted_5 = { class: "my-4 mx-4 p-0 bg-white border-radius-10" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "row m-0 bg-card-light",
  style: {"border-radius":"10px 10px 0px 0px"}
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 d-flex justify-content-center py-4" }, [
    /*#__PURE__*/_createElementVNode("h4", { class: "font-grey p-cursor text-center" }, [
      /*#__PURE__*/_createElementVNode("b", { style: {"color":"#6B7A99"} }, "Corporate Application - Australian Domestic Company")
    ])
  ])
], -1))
const _hoisted_7 = { class: "row my-3 justify-content-center" }
const _hoisted_8 = { class: "col-12 col-sm-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1 col-xl-10 offset-xl-1" }
const _hoisted_9 = { class: "container-fluid" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = { class: "list-unstyled multi-steps" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-none d-md-block" }, "Personal", -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-none d-md-block" }, "Business", -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-none d-md-block" }, "M.D. & Owners", -1))
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-none d-md-block" }, "Shareholders", -1))
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-none d-md-block" }, "External Bank Account", -1))
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-none d-md-block" }, "E-Signature", -1))
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-none d-md-block" }, "Upload Proof", -1))
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = { class: "row my-3 justify-content-center" }
const _hoisted_28 = { class: "col-12 col-sm-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1 col-xl-8 offset-xl-2" }
const _hoisted_29 = { class: "login-card" }
const _hoisted_30 = { class: "login-body company" }
const _hoisted_31 = { class: "row mt-3" }
const _hoisted_32 = { class: "col-md-12 col-12" }
const _hoisted_33 = { class: "form-group" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, [
  /*#__PURE__*/_createTextVNode(" Ref No"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("small", null, "If you have been given a Ref number by Caprock please enter it here.")
], -1))
const _hoisted_35 = { class: "col-md-12 col-12" }
const _hoisted_36 = { class: "form-group" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, [
  /*#__PURE__*/_createTextVNode(" Advisor Ref No"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("small", null, "If you have been given a Advisor Ref number by Caprock please enter it here.")
], -1))
const _hoisted_38 = { class: "col-md-12 col-12" }
const _hoisted_39 = { class: "form-group" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Company Logo", -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_42 = ["src"]
const _hoisted_43 = {
  key: 3,
  class: "progress"
}
const _hoisted_44 = ["aria-valuenow"]
const _hoisted_45 = { class: "col-md-12 col-12" }
const _hoisted_46 = { class: "form-group" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Full company name as registered by asic", -1))
const _hoisted_48 = { class: "col-md-12 col-12" }
const _hoisted_49 = { class: "form-group" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Company Website", -1))
const _hoisted_51 = { class: "col-md-12 col-12" }
const _hoisted_52 = { class: "form-group" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Company registration number", -1))
const _hoisted_54 = { class: "col-md-12 col-12" }
const _hoisted_55 = { class: "form-group" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Investment Currency", -1))
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Please select", -1))
const _hoisted_58 = ["value"]
const _hoisted_59 = { class: "col-md-12 col-12" }
const _hoisted_60 = { class: "form-group" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Expected investment amount", -1))
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Please select", -1))
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "$500k-$50 million" }, "$500k-$50 million", -1))
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "$50-$100 million" }, "$50-$100 million", -1))
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "$100 million +" }, "$100 million +", -1))
const _hoisted_66 = { class: "col-md-12 col-12" }
const _hoisted_67 = { class: "form-group" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "State or Territory in Australia, in which the Company was formed, incorporated or registered", -1))
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Please select", -1))
const _hoisted_70 = ["value"]
const _hoisted_71 = { class: "col-md-12 col-12" }
const _hoisted_72 = { class: "form-group" }
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Type of company", -1))
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Please select", -1))
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "1" }, "Partnership", -1))
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "2" }, "Private", -1))
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "3" }, "Public", -1))
const _hoisted_78 = {
  key: 0,
  class: "col-md-12 col-12"
}
const _hoisted_79 = { class: "form-group" }
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Trust Deed", -1))
const _hoisted_81 = ["innerHTML"]
const _hoisted_82 = {
  key: 3,
  class: "progress"
}
const _hoisted_83 = ["aria-valuenow"]
const _hoisted_84 = { class: "col-md-12 col-12" }
const _hoisted_85 = { class: "form-group" }
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Company year of Incorporation", -1))
const _hoisted_87 = { class: "col-12 col-sm-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1 col-xl-8 offset-xl-1" }
const _hoisted_88 = { class: "row justify-content-end mx-md-0 mx-1 mb-5" }
const _hoisted_89 = { class: "col-3 px-1" }
const _hoisted_90 = { class: "col-3 px-1" }
const _hoisted_91 = { class: "col-3 px-1" }
const _hoisted_92 = { class: "row my-3 justify-content-center" }
const _hoisted_93 = { class: "col-12 col-sm-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1 col-xl-8 offset-xl-3" }
const _hoisted_94 = { class: "login-card" }
const _hoisted_95 = { class: "login-body business" }
const _hoisted_96 = { class: "row mt-3" }
const _hoisted_97 = { class: "col-md-12 col-12" }
const _hoisted_98 = { class: "form-group" }
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Full address of the company's registered office ", -1))
const _hoisted_100 = { class: "form-group place_suggest_c_r d-none" }
const _hoisted_101 = {
  class: "card place_suggest_c_r",
  style: {"max-width":"100%","overflow-y":"scroll","max-height":"250px"}
}
const _hoisted_102 = ["onClick"]
const _hoisted_103 = ["id"]
const _hoisted_104 = { style: {"font-weight":"600","cursor":"pointer"} }
const _hoisted_105 = {
  class: "p-0 m-0",
  style: {"color":"grey","cursor":"pointer"}
}
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "m-0" }, null, -1))
const _hoisted_107 = { class: "col-md-12 col-12" }
const _hoisted_108 = { class: "form-group" }
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Company is registered as:", -1))
const _hoisted_110 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Please select", -1))
const _hoisted_111 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "1" }, "Public", -1))
const _hoisted_112 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "2" }, "Proprietary", -1))
const _hoisted_113 = { class: "col-md-12 col-12" }
const _hoisted_114 = { class: "form-group" }
const _hoisted_115 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "ACN issued to the company", -1))
const _hoisted_116 = { class: "col-md-12 col-12" }
const _hoisted_117 = { class: "form-group" }
const _hoisted_118 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Details of any current or recent prosecutions and inquiries related to Money Laundering, terrorist links, tax offences and corruption in respect of the Company", -1))
const _hoisted_119 = { class: "col-12 col-sm-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1 col-xl-8 offset-xl-1" }
const _hoisted_120 = { class: "row justify-content-end mx-md-0 mx-1 mb-5" }
const _hoisted_121 = { class: "col-3 px-1" }
const _hoisted_122 = { class: "col-3 px-1" }
const _hoisted_123 = { class: "col-3 px-1" }
const _hoisted_124 = { class: "row my-3 justify-content-center" }
const _hoisted_125 = { class: "col-12 col-sm-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1 col-xl-8 offset-xl-3" }
const _hoisted_126 = { class: "login-card" }
const _hoisted_127 = { class: "login-body company" }
const _hoisted_128 = { class: "row mt-3" }
const _hoisted_129 = { class: "col-md-12 col-12" }
const _hoisted_130 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-group" }, [
  /*#__PURE__*/_createElementVNode("h4", { style: {"color":"grey","font-family":"'Merriweather'"} }, " Add Director ")
], -1))
const _hoisted_131 = { class: "form-group" }
const _hoisted_132 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "How many directors / partners are in the organisation. ", -1))
const _hoisted_133 = { class: "row my-3 justify-content-center" }
const _hoisted_134 = { class: "col-12 col-sm-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1 col-xl-8 offset-xl-3" }
const _hoisted_135 = { class: "login-card" }
const _hoisted_136 = { class: "login-body company" }
const _hoisted_137 = { class: "row mt-3" }
const _hoisted_138 = { class: "col-md-12 col-12" }
const _hoisted_139 = { class: "form-group" }
const _hoisted_140 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Please select the director who will be receiving all company's communication.", -1))
const _hoisted_141 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Please select", -1))
const _hoisted_142 = ["value"]
const _hoisted_143 = { class: "col-12 col-sm-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1 col-xl-8 offset-xl-1" }
const _hoisted_144 = { class: "row justify-content-end mx-md-0 mx-1 mb-5" }
const _hoisted_145 = { class: "col-3 px-1" }
const _hoisted_146 = { class: "col-3 px-1" }
const _hoisted_147 = { class: "row my-3 justify-content-center" }
const _hoisted_148 = { class: "col-12 col-sm-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1 col-xl-8 offset-xl-3" }
const _hoisted_149 = { class: "login-card" }
const _hoisted_150 = { class: "login-body company" }
const _hoisted_151 = { class: "row mt-3" }
const _hoisted_152 = { class: "col-md-12 col-12" }
const _hoisted_153 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-group" }, [
  /*#__PURE__*/_createElementVNode("h4", { style: {"color":"grey","font-family":"'Merriweather'"} }, " Add Shareholder ")
], -1))
const _hoisted_154 = { class: "form-group" }
const _hoisted_155 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "How many shareholder / partners are in the organisation. ", -1))
const _hoisted_156 = { class: "row my-3 justify-content-center" }
const _hoisted_157 = { class: "col-12 col-sm-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1 col-xl-8 offset-xl-1" }
const _hoisted_158 = { class: "row justify-content-end mx-md-0 mx-1 mb-5" }
const _hoisted_159 = { class: "col-3 px-1" }
const _hoisted_160 = { class: "col-3 px-1" }
const _hoisted_161 = { class: "row my-3 justify-content-center" }
const _hoisted_162 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12 col-sm-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1 col-xl-8 offset-xl-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "login-card" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "login-body company" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "row mt-3" })
    ])
  ])
], -1))
const _hoisted_163 = { class: "col-12 col-sm-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1 col-xl-8 offset-xl-1" }
const _hoisted_164 = { class: "row justify-content-end mx-md-0 mx-1 mb-5" }
const _hoisted_165 = { class: "col-3 px-1" }
const _hoisted_166 = { class: "col-3 px-1" }
const _hoisted_167 = { class: "row my-3 justify-content-center" }
const _hoisted_168 = { class: "col-12 col-sm-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1 col-xl-8 offset-xl-3" }
const _hoisted_169 = { class: "login-card" }
const _hoisted_170 = { class: "login-body company" }
const _hoisted_171 = { class: "row mt-3" }
const _hoisted_172 = { class: "col-md-12 col-12" }
const _hoisted_173 = { class: "form-group" }
const _hoisted_174 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Name", -1))
const _hoisted_175 = { class: "col-md-12 col-12" }
const _hoisted_176 = { class: "form-group" }
const _hoisted_177 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Email", -1))
const _hoisted_178 = { class: "col-md-12 col-12" }
const _hoisted_179 = { class: "form-group" }
const _hoisted_180 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Phone Number", -1))
const _hoisted_181 = { class: "col-md-12 col-12" }
const _hoisted_182 = { class: "form-group" }
const _hoisted_183 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Date of Birth", -1))
const _hoisted_184 = { class: "col-12 col-sm-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1 col-xl-8 offset-xl-1" }
const _hoisted_185 = { class: "row justify-content-end mx-md-0 mx-1 mb-5" }
const _hoisted_186 = { class: "col-3 px-1" }
const _hoisted_187 = { class: "col-3 px-1" }
const _hoisted_188 = { class: "col-3 px-1" }
const _hoisted_189 = { class: "row my-3 justify-content-center" }
const _hoisted_190 = { class: "col-12 col-sm-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1 col-xl-8 offset-xl-3" }
const _hoisted_191 = { class: "login-card" }
const _hoisted_192 = { class: "login-body company" }
const _hoisted_193 = { class: "row mt-3" }
const _hoisted_194 = { class: "form-group" }
const _hoisted_195 = { class: "font-grey" }
const _hoisted_196 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_197 = ["onClick"]
const _hoisted_198 = ["innerHTML"]
const _hoisted_199 = {
  key: 3,
  class: "progress"
}
const _hoisted_200 = ["aria-valuenow"]
const _hoisted_201 = { class: "col-12 col-sm-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1 col-xl-8 offset-xl-1" }
const _hoisted_202 = { class: "row justify-content-end mx-md-0 mx-1 mb-5" }
const _hoisted_203 = { class: "col-3 px-1" }
const _hoisted_204 = { class: "col-3 px-1" }
const _hoisted_205 = { class: "col-3 px-1" }
const _hoisted_206 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "modal fade sending_email",
  id: "sending_email",
  role: "dialog"
}, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "modal-dialog modal-sm modal-dialog-centered",
    role: "document"
  }, [
    /*#__PURE__*/_createElementVNode("div", { class: "modal-content bg-light" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "modal-body mb-2" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "row mx-1 mt-4" }, [
          /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 text-center" }, [
            /*#__PURE__*/_createElementVNode("p", null, "Sending document to your mail ! Please Wait.....")
          ])
        ])
      ])
    ])
  ])
], -1))
const _hoisted_207 = {
  class: "modal fade cancel_request",
  id: "cancel_request",
  role: "dialog"
}
const _hoisted_208 = {
  class: "modal-dialog modal-md modal-dialog-centered",
  role: "document"
}
const _hoisted_209 = { class: "modal-content" }
const _hoisted_210 = { class: "modal-body mb-2" }
const _hoisted_211 = { class: "row mx-1 mt-1" }
const _hoisted_212 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-12" }, [
  /*#__PURE__*/_createElementVNode("p", { style: {"font-size":"larger"} }, "Cancelling will delete all details entered.")
], -1))
const _hoisted_213 = { class: "col-md-12 text-left" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_basic = _resolveComponent("basic")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!
  const _component_NDirectors = _resolveComponent("NDirectors")!
  const _component_Shareholders = _resolveComponent("Shareholders")!
  const _component_Banks = _resolveComponent("Banks")!
  const _component_toasti = _resolveComponent("toasti")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_basic, { load_on: _ctx.load_on }, null, 8, ["load_on"]),
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _hoisted_10,
                    _hoisted_11,
                    _createElementVNode("ul", _hoisted_12, [
                      _createElementVNode("li", {
                        onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.set_step(1);}),
                        class: _normalizeClass(["p-cursor", {'is-active':_ctx.active_tab=='company'}])
                      }, _hoisted_14, 2),
                      _createElementVNode("li", {
                        onClick: _cache[1] || (_cache[1] = ($event: any) => {_ctx.set_step(2);}),
                        class: _normalizeClass(["p-cursor", {'is-active':_ctx.active_tab=='business'}])
                      }, _hoisted_16, 2),
                      _createElementVNode("li", {
                        onClick: _cache[2] || (_cache[2] = ($event: any) => {_ctx.set_step(3);}),
                        class: _normalizeClass(["p-cursor", {'is-active':_ctx.active_tab=='director'}])
                      }, _hoisted_18, 2),
                      _createElementVNode("li", {
                        onClick: _cache[3] || (_cache[3] = ($event: any) => {_ctx.set_step(4);}),
                        class: _normalizeClass(["p-cursor", {'is-active':_ctx.active_tab=='shareholder'}])
                      }, _hoisted_20, 2),
                      _createElementVNode("li", {
                        onClick: _cache[4] || (_cache[4] = ($event: any) => {_ctx.set_step(5);}),
                        class: _normalizeClass(["p-cursor", {'is-active':_ctx.active_tab=='account'}])
                      }, _hoisted_22, 2),
                      _createElementVNode("li", {
                        onClick: _cache[5] || (_cache[5] = ($event: any) => {_ctx.set_step(6);}),
                        class: _normalizeClass(["p-cursor", {'is-active':_ctx.active_tab=='e_signature'}])
                      }, _hoisted_24, 2),
                      _createElementVNode("li", {
                        onClick: _cache[6] || (_cache[6] = ($event: any) => {_ctx.set_step(7);}),
                        class: _normalizeClass(["p-cursor", {'is-active':_ctx.active_tab=='upload'}])
                      }, _hoisted_26, 2)
                    ])
                  ])
                ])
              ]),
              (this.current_step==1)
                ? (_openBlock(), _createBlock(_component_Form, {
                    key: 0,
                    method: "POST",
                    action: "/",
                    class: "my-1 card p-2",
                    onSubmit: _ctx.submitForm_1
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("div", _hoisted_28, [
                          _createElementVNode("div", _hoisted_29, [
                            _createElementVNode("div", _hoisted_30, [
                              _createElementVNode("div", _hoisted_31, [
                                _createVNode(_component_Field, {
                                  modelValue: this.active_tab,
                                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((this.active_tab) = $event)),
                                  name: "user_type",
                                  id: "user_type",
                                  type: "hidden"
                                }, null, 8, ["modelValue"]),
                                _createElementVNode("div", _hoisted_32, [
                                  _createElementVNode("div", _hoisted_33, [
                                    _hoisted_34,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.form.user_ref_no,
                                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.user_ref_no) = $event)),
                                      placeholder: "ie. CM0011114",
                                      class: "form-control selected-field",
                                      name: "user_ref_no",
                                      id: "user_ref_no",
                                      type: "text",
                                      readonly: ""
                                    }, null, 8, ["modelValue"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "user_ref_no"
                                    })
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_35, [
                                  _createElementVNode("div", _hoisted_36, [
                                    _hoisted_37,
                                    _createVNode(_component_Field, {
                                      readonly: _ctx.advisor_exist==1,
                                      modelValue: _ctx.form.advisor_ref_no,
                                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.advisor_ref_no) = $event)),
                                      placeholder: "ie. A042",
                                      class: "form-control selected-field",
                                      name: "advisor_ref_no",
                                      id: "advisor_ref_no",
                                      type: "text"
                                    }, null, 8, ["readonly", "modelValue"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "advisor_ref_no"
                                    })
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_38, [
                                  _createElementVNode("div", _hoisted_39, [
                                    _hoisted_40,
                                    _hoisted_41,
                                    (typeof _ctx.records.profile_pic_url!='undefined' && _ctx.records.profile_pic_url!='')
                                      ? (_openBlock(), _createBlock(_component_Field, {
                                          key: 0,
                                          onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.uploadFile($event))),
                                          modelValue: _ctx.form.profile_pic,
                                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.form.profile_pic) = $event)),
                                          class: "form-control selected-field",
                                          name: "profile_pic",
                                          type: "file"
                                        }, null, 8, ["modelValue"]))
                                      : _createCommentVNode("", true),
                                    (typeof _ctx.records.profile_pic_url=='undefined' || _ctx.records.profile_pic_url=='')
                                      ? (_openBlock(), _createBlock(_component_Field, {
                                          key: 1,
                                          onChange: _cache[12] || (_cache[12] = ($event: any) => (_ctx.uploadFile($event))),
                                          modelValue: _ctx.form.profile_pic,
                                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.form.profile_pic) = $event)),
                                          class: "form-control selected-field",
                                          name: "profile_pic",
                                          type: "file",
                                          rules: _ctx.requiredField
                                        }, null, 8, ["modelValue", "rules"]))
                                      : _createCommentVNode("", true),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "profile_pic"
                                    }),
                                    (typeof _ctx.records.profile_pic_url!='undefined' && _ctx.records.profile_pic_url!='')
                                      ? (_openBlock(), _createElementBlock("div", {
                                          key: 2,
                                          class: "p-cursor",
                                          onClick: _cache[14] || (_cache[14] = ($event: any) => {_ctx.openDoc(_ctx.records.profile_pic_url);})
                                        }, [
                                          _createElementVNode("img", {
                                            class: "rounded-circle",
                                            style: {"height":"50px"},
                                            src: _ctx.records.profile_pic_url
                                          }, null, 8, _hoisted_42)
                                        ]))
                                      : _createCommentVNode("", true),
                                    (_ctx.form['profile_pic_pdiv']==1)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                                          _createElementVNode("div", {
                                            class: "progress-bar bg-dark",
                                            role: "progressbar",
                                            style: _normalizeStyle({'width':_ctx.form['profile_pic_pbar']+'%'}),
                                            "aria-valuenow": _ctx.form['profile_pic_pbar'],
                                            "aria-valuemin": "0",
                                            "aria-valuemax": "100"
                                          }, _toDisplayString(_ctx.form['profile_pic_pbar_p']), 13, _hoisted_44)
                                        ]))
                                      : _createCommentVNode("", true),
                                    _createVNode(_component_Field, {
                                      rules: _ctx.requiredField,
                                      modelValue: _ctx.form['profile_pic_path'],
                                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.form['profile_pic_path']) = $event)),
                                      class: "form-control selected-field",
                                      name: "profile_pic_path",
                                      type: "hidden"
                                    }, null, 8, ["rules", "modelValue"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "profile_pic_path"
                                    })
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_45, [
                                  _createElementVNode("div", _hoisted_46, [
                                    _hoisted_47,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.form.company_name,
                                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.form.company_name) = $event)),
                                      class: "form-control selected-field",
                                      name: "company_name",
                                      placeholder: "company name here",
                                      type: "text",
                                      rules: [_ctx.requiredField]
                                    }, null, 8, ["modelValue", "rules"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "company_name"
                                    })
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_48, [
                                  _createElementVNode("div", _hoisted_49, [
                                    _hoisted_50,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.form.company_website,
                                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.form.company_website) = $event)),
                                      class: "form-control selected-field",
                                      name: "company_website",
                                      placeholder: "ie. www.caprock.com",
                                      type: "text",
                                      rules: []
                                    }, null, 8, ["modelValue"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "company_website"
                                    })
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_51, [
                                  _createElementVNode("div", _hoisted_52, [
                                    _hoisted_53,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.form.company_registration_no,
                                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.form.company_registration_no) = $event)),
                                      class: "form-control selected-field",
                                      name: "company_registration_no",
                                      placeholder: "ie. IRGE345678",
                                      type: "text",
                                      rules: [_ctx.requiredField]
                                    }, null, 8, ["modelValue", "rules"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "company_registration_no"
                                    })
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_54, [
                                  _createElementVNode("div", _hoisted_55, [
                                    _hoisted_56,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.form.investment_currency,
                                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.form.investment_currency) = $event)),
                                      class: "form-control",
                                      name: "investment_currency",
                                      as: "select",
                                      rules: _ctx.selectField
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_57,
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countries, (country) => {
                                          return (_openBlock(), _createElementBlock("option", {
                                            key: country.country_id,
                                            value: country.country_id
                                          }, _toDisplayString(country.currency) + " - " + _toDisplayString(country.country_name), 9, _hoisted_58))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue", "rules"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "investment_currency"
                                    })
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_59, [
                                  _createElementVNode("div", _hoisted_60, [
                                    _hoisted_61,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.form.investment_amount,
                                      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.form.investment_amount) = $event)),
                                      class: "form-control",
                                      name: "investment_amount",
                                      as: "select",
                                      rules: _ctx.selectField
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_62,
                                        _hoisted_63,
                                        _hoisted_64,
                                        _hoisted_65
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue", "rules"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "investment_amount"
                                    })
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_66, [
                                  _createElementVNode("div", _hoisted_67, [
                                    _hoisted_68,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.form.company_state,
                                      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.form.company_state) = $event)),
                                      class: "form-control",
                                      name: "company_state",
                                      as: "select",
                                      rules: _ctx.selectField
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_69,
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.states, (state) => {
                                          return (_openBlock(), _createElementBlock("option", {
                                            key: state.id,
                                            value: state.id
                                          }, _toDisplayString(state.name), 9, _hoisted_70))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue", "rules"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "company_state"
                                    })
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_71, [
                                  _createElementVNode("div", _hoisted_72, [
                                    _hoisted_73,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.form.company_type,
                                      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.form.company_type) = $event)),
                                      class: "form-control",
                                      name: "company_type",
                                      as: "select",
                                      rules: _ctx.selectField
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_74,
                                        _hoisted_75,
                                        _hoisted_76,
                                        _hoisted_77
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue", "rules"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "company_type"
                                    })
                                  ])
                                ]),
                                (_ctx.form.company_type==4)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                                      _createElementVNode("div", _hoisted_79, [
                                        _hoisted_80,
                                        (typeof _ctx.records.trust_deed_url!='undefined' && _ctx.records.trust_deed_url!='')
                                          ? (_openBlock(), _createBlock(_component_Field, {
                                              key: 0,
                                              onChange: _cache[23] || (_cache[23] = ($event: any) => (_ctx.uploadFile($event))),
                                              modelValue: _ctx.form.trust_deed,
                                              "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.form.trust_deed) = $event)),
                                              class: "form-control selected-field",
                                              name: "trust_deed",
                                              type: "file"
                                            }, null, 8, ["modelValue"]))
                                          : _createCommentVNode("", true),
                                        (typeof _ctx.records.trust_deed_url=='undefined' || _ctx.records.trust_deed_url=='')
                                          ? (_openBlock(), _createBlock(_component_Field, {
                                              key: 1,
                                              onChange: _cache[25] || (_cache[25] = ($event: any) => (_ctx.uploadFile($event))),
                                              modelValue: _ctx.form.trust_deed,
                                              "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.form.trust_deed) = $event)),
                                              class: "form-control selected-field",
                                              name: "trust_deed",
                                              type: "file",
                                              rules: _ctx.requiredField
                                            }, null, 8, ["modelValue", "rules"]))
                                          : _createCommentVNode("", true),
                                        _createVNode(_component_ErrorMessage, {
                                          style: {"color":"#d00000"},
                                          name: "trust_deed"
                                        }),
                                        (typeof _ctx.records.trust_deed_url!='undefined' && _ctx.records.trust_deed_url!='')
                                          ? (_openBlock(), _createElementBlock("div", {
                                              key: 2,
                                              class: "p-cursor",
                                              onClick: _cache[27] || (_cache[27] = ($event: any) => {_ctx.openDoc(_ctx.records.trust_deed_url);})
                                            }, [
                                              _createElementVNode("span", { innerHTML: _ctx.svg_image }, null, 8, _hoisted_81),
                                              _createTextVNode(" Trust Deed ")
                                            ]))
                                          : _createCommentVNode("", true),
                                        (_ctx.form.trust_deed_pdiv==1)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
                                              _createElementVNode("div", {
                                                class: "progress-bar bg-dark",
                                                role: "progressbar",
                                                style: _normalizeStyle({'width':_ctx.form.trust_deed_pbar+'%'}),
                                                "aria-valuenow": _ctx.form.trust_deed_pbar,
                                                "aria-valuemin": "0",
                                                "aria-valuemax": "100"
                                              }, _toDisplayString(_ctx.form.trust_deed_pbar_p), 13, _hoisted_83)
                                            ]))
                                          : _createCommentVNode("", true),
                                        _createVNode(_component_Field, {
                                          rules: _ctx.requiredField,
                                          modelValue: _ctx.form.trust_deed_path,
                                          "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.form.trust_deed_path) = $event)),
                                          class: "form-control selected-field",
                                          name: "trust_deed_path",
                                          type: "hidden"
                                        }, null, 8, ["rules", "modelValue"]),
                                        _createVNode(_component_ErrorMessage, {
                                          style: {"color":"#d00000"},
                                          name: "trust_deed_path"
                                        })
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_84, [
                                  _createElementVNode("div", _hoisted_85, [
                                    _hoisted_86,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.form.incorporation_date,
                                      "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.form.incorporation_date) = $event)),
                                      type: "date",
                                      class: "form-control selected-field",
                                      name: "incorporation_date",
                                      placeholder: "ie. Incorporation Date",
                                      rules: [_ctx.requiredField],
                                      onclick: "this.type='date'",
                                      onfocus: "this.type='date';",
                                      onblur: "(typeof this.value!='undefined' && this.value!='' && this.value!=null) ? this.type='date' : this.type='text'"
                                    }, null, 8, ["modelValue", "rules"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "incorporation_date"
                                    })
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_87, [
                          _createElementVNode("div", _hoisted_88, [
                            _createElementVNode("div", _hoisted_89, [
                              _createElementVNode("button", {
                                type: "button",
                                onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.openModal('cancel_request'))),
                                class: "btn btn-outline-success btn-mobile btn-lg btn-block mt-3 btn-mobile font-size-15-18"
                              }, " Cancel ")
                            ]),
                            _createElementVNode("div", _hoisted_90, [
                              _createElementVNode("button", {
                                onClick: _cache[31] || (_cache[31] = ($event: any) => {_ctx.next_step=1;}),
                                type: "submit",
                                class: "subBtn btn btn-outline-success btn-mobile btn-lg btn-block mt-3 btn-mobile font-size-15-18"
                              }, " Save ")
                            ]),
                            _createElementVNode("div", _hoisted_91, [
                              _createElementVNode("button", {
                                onClick: _cache[32] || (_cache[32] = ($event: any) => {_ctx.next_step=2;}),
                                type: "submit",
                                class: "subBtn btn btn-success btn-mobile btn-lg btn-block mt-3 btn-mobile font-size-15-18"
                              }, " Save & Next ")
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["onSubmit"]))
                : _createCommentVNode("", true),
              (this.current_step==2)
                ? (_openBlock(), _createBlock(_component_Form, {
                    key: 1,
                    method: "POST",
                    action: "/",
                    class: "my-1 card p-2",
                    onSubmit: _ctx.submitForm_2
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_92, [
                        _createElementVNode("div", _hoisted_93, [
                          _createElementVNode("div", _hoisted_94, [
                            _createElementVNode("div", _hoisted_95, [
                              _createElementVNode("div", _hoisted_96, [
                                _createElementVNode("div", _hoisted_97, [
                                  _createElementVNode("div", _hoisted_98, [
                                    _hoisted_99,
                                    _createVNode(_component_Field, {
                                      onKeyup: _cache[33] || (_cache[33] = ($event: any) => {_ctx.textSearch($event,'_c_r');}),
                                      onfocus: "this.setAttribute('autocomplete', 'disable-autocomplete');",
                                      autocomplete: "off",
                                      modelValue: _ctx.form.registered_address,
                                      "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.form.registered_address) = $event)),
                                      class: "form-control selected-field",
                                      name: "registered_address",
                                      type: "text",
                                      rules: _ctx.requiredField
                                    }, null, 8, ["modelValue", "rules"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "registered_address"
                                    })
                                  ]),
                                  _createElementVNode("div", _hoisted_100, [
                                    _createElementVNode("div", _hoisted_101, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.place_list, (item) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: item.id,
                                          onClick: ($event: any) => {_ctx.set_address(item.id,'registered_address','_c_r');},
                                          class: "suggestDiv_c_r"
                                        }, [
                                          _createElementVNode("div", {
                                            class: "d-none",
                                            id: 'addr_'+item.id
                                          }, _toDisplayString(item.address), 9, _hoisted_103),
                                          _createElementVNode("h6", _hoisted_104, _toDisplayString(item.title), 1),
                                          _createElementVNode("p", _hoisted_105, _toDisplayString(item.details), 1)
                                        ], 8, _hoisted_102))
                                      }), 128)),
                                      _hoisted_106
                                    ])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_107, [
                                  _createElementVNode("div", _hoisted_108, [
                                    _hoisted_109,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.form.company_registration_type,
                                      "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.form.company_registration_type) = $event)),
                                      class: "form-control",
                                      name: "company_registration_type",
                                      as: "select",
                                      rules: _ctx.selectField
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_110,
                                        _hoisted_111,
                                        _hoisted_112
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue", "rules"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "company_registration_type"
                                    })
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_113, [
                                  _createElementVNode("div", _hoisted_114, [
                                    _hoisted_115,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.form.company_ACN,
                                      "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.form.company_ACN) = $event)),
                                      class: "form-control selected-field",
                                      name: "company_ACN",
                                      placeholder: "ie. 051 75454 4",
                                      type: "text",
                                      rules: [_ctx.requiredField]
                                    }, null, 8, ["modelValue", "rules"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "company_ACN"
                                    })
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_116, [
                                  _createElementVNode("div", _hoisted_117, [
                                    _hoisted_118,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.form.mal_activity,
                                      "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.form.mal_activity) = $event)),
                                      class: "form-control selected-field",
                                      name: "mal_activity",
                                      placeholder: "",
                                      type: "text",
                                      rules: [_ctx.requiredField]
                                    }, null, 8, ["modelValue", "rules"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "mal_activity"
                                    })
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_119, [
                          _createElementVNode("div", _hoisted_120, [
                            _createElementVNode("div", _hoisted_121, [
                              _createElementVNode("button", {
                                type: "button",
                                onClick: _cache[38] || (_cache[38] = ($event: any) => (_ctx.openModal('cancel_request'))),
                                class: "btn btn-outline-success btn-mobile btn-lg btn-block mt-3 btn-mobile font-size-15-18"
                              }, " Cancel ")
                            ]),
                            _createElementVNode("div", _hoisted_122, [
                              _createElementVNode("button", {
                                onClick: _cache[39] || (_cache[39] = ($event: any) => {_ctx.next_step=2;}),
                                type: "submit",
                                class: "subBtn btn btn-outline-success btn-mobile btn-lg btn-block mt-3 btn-mobile font-size-15-18"
                              }, " Save ")
                            ]),
                            _createElementVNode("div", _hoisted_123, [
                              _createElementVNode("button", {
                                onClick: _cache[40] || (_cache[40] = ($event: any) => {_ctx.next_step=3;}),
                                type: "submit",
                                class: "subBtn btn btn-success btn-mobile btn-lg btn-block mt-3 btn-mobile font-size-15-18"
                              }, " Save & Next ")
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["onSubmit"]))
                : _createCommentVNode("", true),
              (this.current_step==3)
                ? (_openBlock(), _createBlock(_component_Form, {
                    key: 2,
                    method: "POST",
                    action: "/",
                    class: "my-1 card p-2",
                    onSubmit: _ctx.submitForm_3
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_124, [
                        _createElementVNode("div", _hoisted_125, [
                          _createElementVNode("div", _hoisted_126, [
                            _createElementVNode("div", _hoisted_127, [
                              _createElementVNode("div", _hoisted_128, [
                                _createElementVNode("div", _hoisted_129, [
                                  _hoisted_130,
                                  _createElementVNode("div", _hoisted_131, [
                                    _hoisted_132,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.form.no_of_directors,
                                      "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.form.no_of_directors) = $event)),
                                      placeholder: "i.e. 2 ",
                                      class: "form-control selected-field",
                                      name: "no_of_directors",
                                      type: "text",
                                      rules: _ctx.requiredField
                                    }, null, 8, ["modelValue", "rules"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "no_of_directors"
                                    })
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _createVNode(_component_NDirectors, {
                        countries: _ctx.countries,
                        current_step: _ctx.current_step,
                        load_on: _ctx.load_on,
                        onDirectorFetch: _ctx.director_list
                      }, null, 8, ["countries", "current_step", "load_on", "onDirectorFetch"]),
                      _createElementVNode("div", _hoisted_133, [
                        _createElementVNode("div", _hoisted_134, [
                          _createElementVNode("div", _hoisted_135, [
                            _createElementVNode("div", _hoisted_136, [
                              _createElementVNode("div", _hoisted_137, [
                                _createElementVNode("div", _hoisted_138, [
                                  _createElementVNode("div", _hoisted_139, [
                                    _hoisted_140,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.form.default_recipient,
                                      "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.form.default_recipient) = $event)),
                                      class: "form-control",
                                      name: "default_recipient",
                                      as: "select",
                                      rules: _ctx.selectField
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_141,
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.directors, (director) => {
                                          return (_openBlock(), _createElementBlock("option", {
                                            value: director.director_id,
                                            key: director.director_id
                                          }, _toDisplayString(director['director_name']) + " (" + _toDisplayString(director['director_email']) + ")", 9, _hoisted_142))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue", "rules"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "default_recipient"
                                    })
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_143, [
                          _createElementVNode("div", _hoisted_144, [
                            _createElementVNode("div", _hoisted_145, [
                              _createElementVNode("button", {
                                type: "button",
                                onClick: _cache[43] || (_cache[43] = ($event: any) => (_ctx.openModal('cancel_request'))),
                                class: "btn btn-outline-success btn-mobile btn-lg btn-block mt-3 btn-mobile font-size-15-18"
                              }, " Cancel ")
                            ]),
                            _createElementVNode("div", _hoisted_146, [
                              _createElementVNode("button", {
                                onClick: _cache[44] || (_cache[44] = ($event: any) => {_ctx.next_step=4;}),
                                type: "submit",
                                class: "subBtn btn btn-success btn-mobile btn-lg btn-block mt-3 btn-mobile font-size-15-18"
                              }, " Save & Next ")
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["onSubmit"]))
                : _createCommentVNode("", true),
              (this.current_step==4)
                ? (_openBlock(), _createBlock(_component_Form, {
                    key: 3,
                    method: "POST",
                    action: "/",
                    class: "my-1 card p-2",
                    onSubmit: _ctx.submitForm_4
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_147, [
                        _createElementVNode("div", _hoisted_148, [
                          _createElementVNode("div", _hoisted_149, [
                            _createElementVNode("div", _hoisted_150, [
                              _createElementVNode("div", _hoisted_151, [
                                _createElementVNode("div", _hoisted_152, [
                                  _hoisted_153,
                                  _createElementVNode("div", _hoisted_154, [
                                    _hoisted_155,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.form.no_of_shareholders,
                                      "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.form.no_of_shareholders) = $event)),
                                      placeholder: "i.e. 2 ",
                                      class: "form-control selected-field",
                                      name: "no_of_shareholders",
                                      type: "text",
                                      rules: _ctx.requiredField
                                    }, null, 8, ["modelValue", "rules"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "no_of_shareholders"
                                    })
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _createVNode(_component_Shareholders, {
                        countries: _ctx.countries,
                        current_step: _ctx.current_step,
                        load_on: _ctx.load_on,
                        onShareholderFetch: _ctx.shareholder_list
                      }, null, 8, ["countries", "current_step", "load_on", "onShareholderFetch"]),
                      _createElementVNode("div", _hoisted_156, [
                        _createElementVNode("div", _hoisted_157, [
                          _createElementVNode("div", _hoisted_158, [
                            _createElementVNode("div", _hoisted_159, [
                              _createElementVNode("button", {
                                type: "button",
                                onClick: _cache[46] || (_cache[46] = ($event: any) => (_ctx.openModal('cancel_request'))),
                                class: "btn btn-outline-success btn-mobile btn-lg btn-block mt-3 btn-mobile font-size-15-18"
                              }, " Cancel ")
                            ]),
                            _createElementVNode("div", _hoisted_160, [
                              _createElementVNode("button", {
                                onClick: _cache[47] || (_cache[47] = ($event: any) => {_ctx.next_step=5;}),
                                type: "submit",
                                class: "subBtn btn btn-success btn-mobile btn-lg btn-block mt-3 btn-mobile font-size-15-18"
                              }, " Save & Next ")
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["onSubmit"]))
                : _createCommentVNode("", true),
              (this.current_step==5)
                ? (_openBlock(), _createBlock(_component_Banks, {
                    key: 4,
                    countries: _ctx.countries,
                    current_step: _ctx.current_step,
                    load_on: _ctx.load_on
                  }, null, 8, ["countries", "current_step", "load_on"]))
                : _createCommentVNode("", true),
              (this.current_step==5)
                ? (_openBlock(), _createBlock(_component_Form, {
                    key: 5,
                    method: "POST",
                    action: "/",
                    class: "my-1 card p-2",
                    onSubmit: _ctx.submitForm_5
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_161, [
                        _hoisted_162,
                        _createElementVNode("div", _hoisted_163, [
                          _createElementVNode("div", _hoisted_164, [
                            _createElementVNode("div", _hoisted_165, [
                              _createElementVNode("button", {
                                type: "button",
                                onClick: _cache[48] || (_cache[48] = ($event: any) => (_ctx.openModal('cancel_request'))),
                                class: "btn btn-outline-success btn-mobile btn-lg btn-block mt-3 btn-mobile font-size-15-18"
                              }, " Cancel ")
                            ]),
                            _createElementVNode("div", _hoisted_166, [
                              _createElementVNode("button", {
                                onClick: _cache[49] || (_cache[49] = ($event: any) => {_ctx.next_step=6;}),
                                type: "submit",
                                class: "subBtn btn btn-success btn-mobile btn-lg btn-block mt-3 btn-mobile font-size-15-18"
                              }, " Save & Next ")
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["onSubmit"]))
                : _createCommentVNode("", true),
              (this.current_step==6)
                ? (_openBlock(), _createBlock(_component_Form, {
                    key: 6,
                    method: "POST",
                    action: "/",
                    class: "my-1 card p-2",
                    onSubmit: _ctx.submitForm_6
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_167, [
                        _createElementVNode("div", _hoisted_168, [
                          _createElementVNode("div", _hoisted_169, [
                            _createElementVNode("div", _hoisted_170, [
                              _createElementVNode("div", _hoisted_171, [
                                _createElementVNode("div", _hoisted_172, [
                                  _createElementVNode("div", _hoisted_173, [
                                    _hoisted_174,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.form.esign_name,
                                      "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((_ctx.form.esign_name) = $event)),
                                      placeholder: "i.e. Jonaten ",
                                      class: "form-control selected-field",
                                      name: "esign_name",
                                      type: "text",
                                      rules: _ctx.requiredField
                                    }, null, 8, ["modelValue", "rules"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "esign_name"
                                    })
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_175, [
                                  _createElementVNode("div", _hoisted_176, [
                                    _hoisted_177,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.form.esign_email_id,
                                      "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => ((_ctx.form.esign_email_id) = $event)),
                                      placeholder: "i.e. email@address.com  ",
                                      class: "form-control selected-field",
                                      name: "esign_email_id",
                                      type: "text",
                                      rules: [_ctx.requiredField,_ctx.validateEmail]
                                    }, null, 8, ["modelValue", "rules"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "esign_email_id"
                                    })
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_178, [
                                  _createElementVNode("div", _hoisted_179, [
                                    _hoisted_180,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.form.esign_phone_no,
                                      "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((_ctx.form.esign_phone_no) = $event)),
                                      placeholder: "i.e. 3539 000556  ",
                                      class: "form-control selected-field",
                                      name: "esign_phone_no",
                                      type: "text",
                                      rules: [_ctx.requiredField,_ctx.mobileField]
                                    }, null, 8, ["modelValue", "rules"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "esign_phone_no"
                                    })
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_181, [
                                  _createElementVNode("div", _hoisted_182, [
                                    _hoisted_183,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.form.esign_dob,
                                      "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => ((_ctx.form.esign_dob) = $event)),
                                      class: "form-control selected-field",
                                      name: "esign_dob",
                                      type: "date",
                                      rules: _ctx.requiredField,
                                      onclick: "this.type='date'",
                                      onfocus: "this.type='date';",
                                      onblur: "(typeof this.value!='undefined' && this.value!='' && this.value!=null) ? this.type='date' : this.type='text'",
                                      placeholder: "D.O.B"
                                    }, null, 8, ["modelValue", "rules"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "esign_dob"
                                    })
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_184, [
                          _createElementVNode("div", _hoisted_185, [
                            _createElementVNode("div", _hoisted_186, [
                              _createElementVNode("button", {
                                type: "button",
                                onClick: _cache[54] || (_cache[54] = ($event: any) => (_ctx.openModal('cancel_request'))),
                                class: "btn btn-outline-success btn-mobile btn-lg btn-block mt-3 btn-mobile font-size-15-18"
                              }, " Cancel ")
                            ]),
                            _createElementVNode("div", _hoisted_187, [
                              _createElementVNode("button", {
                                onClick: _cache[55] || (_cache[55] = ($event: any) => {_ctx.next_step=6;}),
                                type: "submit",
                                class: "subBtn btn btn-outline-success btn-mobile btn-lg btn-block mt-3 btn-mobile font-size-15-18"
                              }, " Save ")
                            ]),
                            _createElementVNode("div", _hoisted_188, [
                              _createElementVNode("button", {
                                onClick: _cache[56] || (_cache[56] = ($event: any) => {_ctx.next_step=7;}),
                                type: "submit",
                                class: "subBtn btn btn-success btn-mobile btn-lg btn-block mt-3 btn-mobile font-size-15-18"
                              }, " Save & Next ")
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["onSubmit"]))
                : _createCommentVNode("", true),
              (this.current_step==7)
                ? (_openBlock(), _createBlock(_component_Form, {
                    key: 7,
                    method: "POST",
                    action: "/",
                    class: "my-1 card p-2",
                    onSubmit: _ctx.submitForm_7
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_189, [
                        _createElementVNode("div", _hoisted_190, [
                          _createElementVNode("div", _hoisted_191, [
                            _createElementVNode("div", _hoisted_192, [
                              _createElementVNode("div", _hoisted_193, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.upload_docs, (upload_doc) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    class: "col-md-12 col-12",
                                    key: upload_doc.input_name
                                  }, [
                                    _createElementVNode("div", _hoisted_194, [
                                      _createElementVNode("label", _hoisted_195, _toDisplayString(upload_doc.name), 1),
                                      _hoisted_196,
                                      (typeof _ctx.records[upload_doc.input_name+'_url']!='undefined' && _ctx.records[upload_doc.input_name+'_url']!='')
                                        ? (_openBlock(), _createBlock(_component_Field, {
                                            key: 0,
                                            onChange: _cache[57] || (_cache[57] = ($event: any) => (_ctx.uploadFile($event))),
                                            modelValue: _ctx.form.driver_license,
                                            "onUpdate:modelValue": _cache[58] || (_cache[58] = ($event: any) => ((_ctx.form.driver_license) = $event)),
                                            class: "form-control selected-field",
                                            name: "driver_license",
                                            type: "file"
                                          }, null, 8, ["modelValue"]))
                                        : _createCommentVNode("", true),
                                      (typeof _ctx.records[upload_doc.input_name+'_url']=='undefined' || _ctx.records[upload_doc.input_name+'_url']=='')
                                        ? (_openBlock(), _createBlock(_component_Field, {
                                            key: 1,
                                            onChange: _cache[59] || (_cache[59] = ($event: any) => (_ctx.uploadFile($event))),
                                            modelValue: _ctx.form[upload_doc.input_name],
                                            "onUpdate:modelValue": ($event: any) => ((_ctx.form[upload_doc.input_name]) = $event),
                                            class: "form-control selected-field",
                                            name: upload_doc.input_name,
                                            type: "file",
                                            rules: _ctx.requiredField
                                          }, null, 8, ["modelValue", "onUpdate:modelValue", "name", "rules"]))
                                        : _createCommentVNode("", true),
                                      _createVNode(_component_ErrorMessage, {
                                        style: {"color":"#d00000"},
                                        name: upload_doc.input_name
                                      }, null, 8, ["name"]),
                                      (typeof _ctx.records[upload_doc.input_name+'_url']!='undefined' && _ctx.records[upload_doc.input_name+'_url']!='')
                                        ? (_openBlock(), _createElementBlock("div", {
                                            key: 2,
                                            class: "p-cursor",
                                            onClick: ($event: any) => {_ctx.openDoc(_ctx.records[upload_doc.input_name+'_url']);}
                                          }, [
                                            _createElementVNode("span", { innerHTML: _ctx.svg_image }, null, 8, _hoisted_198),
                                            _createTextVNode(" " + _toDisplayString(upload_doc.name), 1)
                                          ], 8, _hoisted_197))
                                        : _createCommentVNode("", true),
                                      (_ctx.form[upload_doc.input_name+'_pdiv']==1)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_199, [
                                            _createElementVNode("div", {
                                              class: "progress-bar bg-dark",
                                              role: "progressbar",
                                              style: _normalizeStyle({'width':_ctx.form[upload_doc.input_name+'_pbar']+'%'}),
                                              "aria-valuenow": _ctx.form[upload_doc.input_name+'_pbar'],
                                              "aria-valuemin": "0",
                                              "aria-valuemax": "100"
                                            }, _toDisplayString(_ctx.form[upload_doc.input_name+'_pbar_p']), 13, _hoisted_200)
                                          ]))
                                        : _createCommentVNode("", true),
                                      _createVNode(_component_Field, {
                                        rules: _ctx.requiredField,
                                        modelValue: _ctx.form[upload_doc.input_name+'_path'],
                                        "onUpdate:modelValue": ($event: any) => ((_ctx.form[upload_doc.input_name+'_path']) = $event),
                                        class: "form-control selected-field",
                                        name: upload_doc.input_name+'_path',
                                        type: "hidden"
                                      }, null, 8, ["rules", "modelValue", "onUpdate:modelValue", "name"]),
                                      _createVNode(_component_ErrorMessage, {
                                        style: {"color":"#d00000"},
                                        name: upload_doc.input_name+'_path'
                                      }, null, 8, ["name"])
                                    ])
                                  ]))
                                }), 128))
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_201, [
                          _createElementVNode("div", _hoisted_202, [
                            _createElementVNode("div", _hoisted_203, [
                              _createElementVNode("button", {
                                type: "button",
                                onClick: _cache[60] || (_cache[60] = ($event: any) => (_ctx.openModal('cancel_request'))),
                                class: "btn btn-outline-success btn-mobile btn-lg btn-block mt-3 btn-mobile font-size-15-18"
                              }, " Cancel ")
                            ]),
                            _createElementVNode("div", _hoisted_204, [
                              _createElementVNode("button", {
                                onClick: _cache[61] || (_cache[61] = ($event: any) => {_ctx.next_step=7;}),
                                type: "submit",
                                class: "subBtn btn btn-outline-success btn-mobile btn-lg btn-block mt-3 btn-mobile font-size-15-18"
                              }, " Save ")
                            ]),
                            _createElementVNode("div", _hoisted_205, [
                              _createElementVNode("button", {
                                onClick: _cache[62] || (_cache[62] = ($event: any) => {_ctx.next_step=200;}),
                                type: "submit",
                                class: "subBtn btn btn-success btn-mobile btn-lg btn-block mt-3 btn-mobile font-size-15-18"
                              }, " Save & Finish ")
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["onSubmit"]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ]),
    _hoisted_206,
    _createElementVNode("div", _hoisted_207, [
      _createElementVNode("div", _hoisted_208, [
        _createElementVNode("div", _hoisted_209, [
          _createElementVNode("div", _hoisted_210, [
            _createElementVNode("div", _hoisted_211, [
              _hoisted_212,
              _createElementVNode("div", _hoisted_213, [
                _createElementVNode("button", {
                  class: "ok_btn",
                  onClick: _cache[63] || (_cache[63] = ($event: any) => (_ctx.cancel_request(2)))
                }, "Ok"),
                _createElementVNode("button", {
                  onClick: _cache[64] || (_cache[64] = ($event: any) => (_ctx.closeModal('cancel_request'))),
                  class: "cancel_btn ml-2"
                }, "Cancel")
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_toasti, { ref: "toasti" }, null, 512)
  ], 64))
}